import React from 'react';
import { getLoader } from './user-select';
import AsyncSelect from 'react-select/async';
import { GroupBase, StylesConfig } from 'react-select';

export type User = {
  id: string;
  internalId: number | null;
  phone?: string | null;
  name?: string | null;
};

type UserSelectProps = {
  onChange?: (data: User[]) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  name: string;
  placeholder?: string;
  value: User[];
  roles?: string[];
  styles?: StylesConfig<User, true, GroupBase<User>>;
  isDisabled?: boolean;
};

export const UserMultiSelect = React.forwardRef(function (
  props: UserSelectProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  return (
    <AsyncSelect
      isDisabled={props.isDisabled}
      name={props.name}
      placeholder={props.placeholder}
      onBlur={props.onBlur}
      loadOptions={getLoader(props.roles ?? ['client'])}
      cacheOptions
      defaultOptions
      getOptionLabel={(option) =>
        option.internalId
          ? `ID ${option.internalId} / ${option.phone} / ${option.name}`
          : `${option.phone} / ${option.name}`
      }
      getOptionValue={(option) => option.id}
      isMulti={true}
      onChange={(users) =>
        props.onChange ? props.onChange(users.concat()) : undefined
      }
      onFocus={props.onFocus}
      styles={props.styles}
      value={props.value}
      // @ts-ignore
      ref={ref}
    />
  );
});
